//virtual hosts
const hostname = window.location.hostname;

// Environment hostname mappings
const ENV_HOSTNAMES = {
	PROD: ["app.factoreal.com", "me.satis.fi"],
	QA: ["me.satisfi7.com"],
	STAGE: ["me.satisfi4.com"],
};

// for server
let host = `${window.location.origin}/api/v1`;
let audienceHost = `${window.location.origin}/api/am/v1`;
let apiHost = "https://api.me.satisfi7.com/internal";
// Base for the reports CMS (Strapi). Deployed: same-origin as `host`.
// Localhost: the Vite dev-proxy path (see `/cms-api` in vite.config.ts) so the
// /reports/access cookie and the iframe bundle load are both same-origin.
let reportsHost = host;

if (hostname === "localhost") {
	apiHost = "https://api.me.satisfi4.com/internal";
	host = "https://me.satisfi4.com/api/v1";
	audienceHost = "https://me.satisfi4.com/api/am/v1";
	reportsHost = "/cms-api";
} else if (hostname === "app.factoreal.com") {
	apiHost = "https://api.factoreal.com/internal";
} else if (hostname === "me.satisfi7.com") {
	apiHost = "https://api.me.satisfi7.com/internal";
} else if (hostname === "me.satisfi4.com") {
	apiHost = "https://api.me.satisfi4.com/internal";
} else if (hostname === "me.satis.fi") {
	apiHost = "https://api.me.satis.fi/internal";
}

const constants = {
	// redirection
	dash_redirection: "/segments",

	environments: {
		"app.factoreal.com": "production",
		"me.satis.fi": "production",
		"me.satisfi7.com": "staging",
		"me.satisfi4.com": "development",

		"prime2.factoreal.info": "staging",
		"optimus.factoreal.info": "development",
		localhost: "development",
	},

	//Add new domain at the end of this array
	all_domains: [
		"localhost",
		"app.factoreal.com",
		"me.satis.fi",
		"me.satisfi4.com",
		"me.satisfi7.com",
	],

	captcha_whitelist: ["app.factoreal.com", "me.satis.fi"],

	all_env_hostnames: ENV_HOSTNAMES,
	EMAIL_VALIDATION_REGEX: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

	matomoScripts: {
		"me.satisfi7.com": {
			siteId: "65",
			matomoUrl: "https://me.satisfi4.com/analytics",
		},
		"me.satisfi4.com": {
			siteId: "65",
			matomoUrl: "https://me.satisfi4.com/analytics",
		},
		localhost: {
			siteId: "65",
			matomoUrl: "https://me.satisfi4.com/analytics",
		},
		"app.factoreal.com": {
			siteId: "65",
			matomoUrl: "https://me.satisfi4.com/analytics",
		},
		"me.satis.fi": {
			siteId: "65",
			matomoUrl: "https://me.satisfi4.com/analytics",
		},
	},
	brandLogo: "satisfi_white.svg",
	brandTagLine: false,
	headerTitle: "Marketing Engine",

	// Linkedin Details
	linkedin_id: "86vz4grmu537j1",
	linkedin_redirect: `${window.location.protocol}//${window.location.host}/linkedin`,
	linkedin_scope:
		"r_basicprofile,w_organization_social,w_member_social,rw_organization_admin,r_organization_social",
	facebook_app_id: "1520412201784648",
	fb_version: "v23.0",
	enterprise_details: `${host}/enterprise-details`,
	sms_journey: `${host}/sms/journey-list`,
	getRandomProductsUrl: `${host}/shopify/cart/getRandom/10`,
	customJs: `${window.location.origin}/api/v1/customJS.js`,
	customJSForm: (() => {
		const all_env_hostnames = ENV_HOSTNAMES;
		if (all_env_hostnames.STAGE.includes(hostname)) {
			return "https://storage.googleapis.com/factoreal-optimus-g1-tracker/optimus/contact_widget.js";
		} else if (all_env_hostnames.QA.includes(hostname)) {
			return "https://storage.googleapis.com/factoreal-prime-g1-tracker/prime/contact_widget.js";
		} else if (all_env_hostnames.PROD.includes(hostname)) {
			return `https://storage.googleapis.com/factoreal-g1-tracker/contact_widget.js`;
		}else {
		return 	``
		}
	})(),
	unsubscribe_link: `${window.location.origin}/api/v1/ftreal/unsubscribe`,
	customCSS: `${window.location.origin}/api/v1/customCSS.css`,
	cartWidgetIcon: `${window.location.origin}/api/v1/shopping-cart.png`,
	cart_url: "[Cart_URL]",
	checkout_url: "[Checkout_URL]",
	email_archive: "[Email_Archive_Link]",
	ad_settings_url: `${window.location.origin}/settings/ads-integrations`,
	claims: `${host}/claims`,
	fetchaddata: `${host}/fetchaddata`,
	upload_video: `${host}/upload_video`,
	mediamanager: `${host}/bucket/get_all_images`,
	mediamanager_upload: `${host}/bucket/upload_file`,
	media_upload: `${host}/bucket/upload_media`,
	get_accessible_images: `${host}/get_accessible_images`,
	insert_factoreal_campaign: `${host}/insert_factoreal_campaign`,
	activedomains: `${host}/activedomains`,
	footers_api: `${host}/customrows`,
	list_footer_api: `${audienceHost}/customrow`,
	socket_url: "",
	fb_preview: `${host}/fb_preview`,
	getAllSocialPages: `${host}/factorealcampaigns/getAllSocialPages`,
	test_email: `${host}/factorealcampaigns/templateTest`,
	graphql: `${host}/graphql`,
	audience_search: `${host}/searchaudiences`,
	upload: `${host}/upload`,
	available_tags: `${host}/available_tags`,
	get_products: `${host}/get_products`,
	checkJorenyCreationAllowed: `${host}/allow_campaign_creation`,
	list: `${host}/list`,
	accessible_list: `${host}/accessible_list`,
	audience_list: `${host}/audience_list`,
	acessible_list_sms: `${host}/sms-accessiblefolder/journey-list`,
	whatsapp_journeys: `${host}/whatsapp-accessiblefolder/journey-list`,
	whatsapp_journeys_audience: `${host}/whatsappjournies/journey-list`,
	domainmanagers: `${host}/domainmanagers`,
	email_verify_sender: `${host}/confirm_email_send`,
	product: `${host}/product`,
	reportsHost,
	reportAccess: `${reportsHost}/reports/access`,
	journeybuilders: `${host}/journeybuilders`,
	journeybuilders_check_double_optin: `${host}/journeybuilders/check_double_optin`,
	journeygoal: `${host}/journeygoals`,
	audienceByName: `${host}/audiences/exact/name/`,
	factorealTemplate: `${host}/factorealtemplates`,
	previewUrl: `${window.location.origin}/preview`,
	factorealTemplateByName: `${host}/factorealtemplatesByName`,
	datasourceuploads: `${host}/datasourceuploads`,
	datasourceuploads_confirmation: `${host}/datasourceuploads/confirmation`,
	triggers: `${host}/triggers`,
	enterprises: `${host}/enterprises`,
	usersavedblocks: `${host}/usersavedblocks`,
	channels: `${host}/channels`,
	goals: `${host}/goals`,
	forms: `${host}/forms`,
	copyForm: `${host}/copyForm`,
	event_list: `${host}/audiences/get_all_session`,
	audience_dashboard: `${host}/audience_dashboard`,
	answer: `${host}/forms/answer`,
	usertemplates: `${host}/usertemplates`,
	landingpage: `${host}/landingpages`,
	form_creation_allowed: `${host}/is_creation_allowed`,
	check_unique_form: `${host}/check-unique-form`,
	landingpageReports: `${host}/landingpagereports`,
	individualLandingpageReports: `${host}/individual-landingpagereports`,
	fetchContactsColumnData: `${host}/fetchContactsColumnData`,
	submit: `${host}/landingform/submit`,
	factorealtemplates: `${host}/factorealtemplates`,
	enterprisetemplates: `${host}/enterprisetemplates`,
	jagscampaign: `${host}/factorealcampaigns/campaign/jags`,
	smsreport: `${host}/factorealcampaigns/campaign/smsdashboard`,
	journeytemplates: `${host}/journeytemplates`,
	journeytemplateurls: `${host}/journeytemplateurls`,
	journeyvtresults: `${host}/journeyvtresults/variant_testing`,
	factorealcampaigndata: `${host}/factorealcampaigndata`,
	factorealcampaigntest: `${host}/factorealcampaigns/test`,
	factorealcampaigns: `${host}/factorealcampaigns`,
	facebook_abort: `${host}/factorealcampaign/abort`,
	get_data: `${host}/datasourceuploads/get_headers`,
	userSignup: `${host}/auth/local/register`,
	userSignIn: `${host}/auth/local`,
	otpValidation: `${host}/users-permissions/auth/verify-otp`,
	resendOTP: `${host}/users-permissions/auth/resend-otp`,
	getRecipientscount: `${host}/getRecipientscount/`,
	getCustomRecipientscount: `${host}/getCustomRecipientscount/`,
	addNewUser: `${host}/users-permissions/auth/addEnterpriseUser`,
	editUser: `${host}/users-permissions/auth/editUser`,
	rolecategories: `${host}/rolecategories`,
	getBots: `${host}/get_enterprise_bot_details`,
	botKeyWords: `${host}/botaccounts/list-keywords`,
	configure_keywords: `${host}/botaccounts/configure-keywords`,
	remove_keywords: `${host}/botaccounts/remove-keywords`,
	getIndividualWhatsapp: `${audienceHost}/individual_whatsapp_journey_campaign`,
	getClickedWhatsapp: `${audienceHost}/individual_whatsapp_journey_clicked`,
	getSkippedWhatsapp: `${audienceHost}/individual_whatsapp_journey_skipped`,
	getRepliedWhatsapp: `${audienceHost}/individual_whatsapp_journey_replied`,
	getFailedWhatsapp: `${audienceHost}/individual_whatsapp_journey_failed`,
	getAudienceDownload: `${audienceHost}/audience/download_contacts`,
	getHomeScreenDashboard: `${audienceHost}/newdashboard`,
	getSegmentsDashboard: `${audienceHost}/newsegmentdashboard`,
	getDashboardCard: `${audienceHost}/dashboardcards`,
	getAudienceGraph: `${audienceHost}/audiencegraph`,
	getRole: `${host}/factorealroles/rolecategory/`,
	getUserRole: `${host}/factorealroles/:id`,
	getUserDetails: `${host}/users-permissions/user-details`,
	confirmNewUser: `${host}/users-permissions/auth/confirmEnterpriseUser`,
	users: `${host}/users`,
	forgotPassword: `${host}/auth/forgot-password`,
	resetPassword: `${host}/auth/reset-password`,
	setNewPassword: `${host}/auth/set-init-password`,
	changePassword: `${host}/users-permissions/auth/updatePassword`,
	checkEmailExist: `${host}/users-permissions/auth/userEmailExist`,
	signUpTnC: `${host}/termsandconditions?type=USER_ONBOARDING`,
	shopifyForwardingUrl: host,
	contact: `${host}/contact`,
	consentActivityLog: `${host}/consent-activity-logs`,
	list_counts: `${host}/list_counts`,
	ticketcontactscolumndata: `${host}/customobjects/getAudienceData`,
	getcustomtriggerdata: `${host}/customtriggers`,
	checkAudienceName: `${host}/audiences/name/`,
	audience: `${host}/audiences`,
	audiences_check: `${host}/audiences_check`,
	copyAudience: `${host}/audiences/copy/`,
	audienceCount: `${host}/audiences/fetch/audiencefilter`,
	audienceExactNameMatch: `${host}/audiences/exact/name/`,
	listAudienceCount: `${host}/audiences/count/`,
	confirmrunpause: `${host}/factorealcampaigns/confirmrunpause`,
	searchAudience: `${host}/audiences/name`,
	socialFBLogin: `${host}/connect/facebook`,
	socialGoogleLogin: `${host}/connect/google`,
	audienceGraph: `${host}/audience/graph`,
	emailApproveCampaign: `${host}/email/:id/approve`,
	emailRejectCampaign: `${host}/email/:id/reject`,
	emailIndividualCampaign: `${audienceHost}/individual_campaign`,
	emailIndividualCampaignContactActivityTable: `${audienceHost}/individual_campaign/contact_activity`,
	smsIndividualCampaign: `${audienceHost}/individual_sms_campaign`,
	emailIndividualCampaignReport: `${audienceHost}/campaign_reports`,
	emailIndividualJourneyReport: `${audienceHost}/journey_reports`,
	clickedSmsCampaign: `${audienceHost}/clicked_sms_campaign`,
	allSmsCampaign: `${audienceHost}/all_sms_campaign`,
	skippedSmsCampaign: `${audienceHost}/skipped_sms_campaign`,
	failedSmsCampaign: `${audienceHost}/failed_sms_campaign`,
	smsJourneyDashboard: `${audienceHost}/sms/journey/dashboard`,
	smsjourneyIndividualCampaign: `${audienceHost}/individual_sms_journey_campaign`,
	allJourneySmsCampaign: `${audienceHost}/all_sms_journey_campaign`,
	clickedJourneySmsCampaign: `${audienceHost}/clicked_sms_journey_campaign`,
	skippedjourneySmsCampaign: `${audienceHost}/skipped_sms_journey_campaign`,
	failedJourneySmsCampaign: `${audienceHost}/failed_sms_journey_campaign`,
	getTemplateBasedOnStatus: `${host}/template_status_filter`,
	googleCallback: `${host}/auth/google/callback?access_token=`,
	facebookCallback: `${host}/auth/facebook/callback?access_token=`,
	allAudience: `${host}/audience/:id/all_contacts`,
	audiencefilter: `${audienceHost}/audiencefilter`,
	facebookFilter: `${audienceHost}/fbauidence/count`,
	audienceAuth: sessionStorage.getItem("user_token"),
	contactscolumndata: `${host}/contactscolumndata`,
	contactscolumndataunique: `${host}/contactscolumndata/getunique`,
	single_contact: `${host}/single_contact`,
	conversational_next_response: `${host}/nextResponse`,
	getForm: `${host}/factorealform`,
	getLandingPage: `${host}/factoreallandingpage`,
	getIndividualContact: `${host}/fetchIndividualContact`,
	formSubmit: `${host}/factorealform/submit`,
	customer: `${host}/customers`,
	customer_count: `${host}/customers/customerCount`,
	email_search: `${host}/email_search`,
	emailsenders: `${host}/emailsenders`,
	enterpriseemailsenders: `${host}/enterpriseemailsenders`,
	contactDashboard: `${host}/customers/dashboard`,
	recaptchaSitekey: "6LddOl8pAAAAAEbvxqF2s1x33u6Hnkg2Yymj6QGf",
	contactRemove: `${host}/contact_remove`,
	contactListMap: `${host}/contact_list_map`,
	contactNewListMap: `${host}/contact_new_list_map`,
	contactFolderListMap: `${host}/contact_folder_list_map`,
	dashboard: `${audienceHost}/dashboard`,
	campaign_dashboard: `${audienceHost}/campaign/dashboard`,
	SMS_CAMPAIGNS_URL: `${host}/factorealcampaigns/sms-campaigns`,
	EMAIL_CAMPAIGNS_URL: `${audienceHost}/email-campaign/dashboard`,
	SOCIAL_CAMPAIGNS_URL: `${audienceHost}/social-campaign/dashboard`,
	SOCIAL_ADS_URL: `${audienceHost}/social-ad/dashboard`,
	post_stats: `${audienceHost}/post_insight`,
	contact_dashboard: `${host}/contactdashboard`,
	contact_dashboard_total: `${host}/contactdashboard/total`,
	contact_dashboard_inactive: `${host}/contactdashboard/inactive`,
	contact_dashboard_source: `${host}/contactdashboard/source`,
	contact_dashboard_inactive_pay: `${host}/contactdashboard/inactivepay`,
	contact_dashboard_pay: `${host}/contactdashboard/pay`,
	contact_dashboard_web_graph: `${host}/contactdashboard/webgraph`,
	contact_dashboard_mobile_graph: `${host}/contactdashboard/mobilegraph`,
	contact_dashboard_inactvecount: `${audienceHost}/inactive_contacts_count`,
	contact_dashboard_web: `${host}/contactdashboard/web`,
	contact_dashboard_mobile: `${host}/contactdashboard/mobile`,
	CAMPAIGNS_COUNT_URL: `${host}/factorealcampaigns/count`,
	unsubscribeorblacklist: `${host}/unsubscribeorblacklist`,
	contact_update: `${host}/contact_update`,
	forgot_password_payload_url: "/resetpassword",
	multiContactRemove: `${host}/multi_contact_remove`,
	customerfromlist: `${host}/customers/lists`,
	removeFromAllLists: `${host}/remove_from_all_lists`,
	removeSmsConsent: `${host}/remove_consent`,
	setSmsConsent: `${host}/set_consent`,
	removeFromList: `${host}/contact_remove_list`,
	createClone: `${host}/factorealcampaigns/createClone/`,
	cloneSmsCampaign: `${host}/smscampaign/clone`,
	launchSmsCampaign: `${host}/smscampaign/launch`,
	resumeSmsCampaign: `${host}/smscampaign/resume`,
	deleteSmsCampaign: `${host}/smscampaigns`,
	abortSmsCampaign: `${host}/smscampaign/abort`,
	cloneList: `${host}/clone_list`,
	campaignjobs: `${host}/campaignjobs`,
	registeredwebsites: `${host}/registeredwebsites`,
	do_not_track_post: `${host}/edit/do_not_track`,
	do_not_track_get: `${host}/do_not_track_list`,
	do_not_track_delete: `${host}/delete/do_not_track`,
	customevents: `${host}/customevents`,
	cookieDataUrl: `${host}/cookieconsentconfigs`,
	generateTokenForWebsite: `${host}/generateToken`,
	checkURLVerificationStatus: `${host}/checkURLVerificationStatus`,
	individual_contact_hsitory: `${host}/contact_activity`,
	facebookads: `${host}/fbads/`,
	creates_ads: `${audienceHost}/creates_ads`,
	reach_events_count: `${audienceHost}/reach_events_count`,
	fb_reach_count: `${audienceHost}/fb_customaudience_count`,
	walletinfo: `${host}/walletinfos`,
	plans: `${host}/plans`,
	session: `${host}/puchaseplan`,
	updateSubscription: `${host}/updatesubscription`,
	addbalance: `${host}/addbalance`,
	updateBalance: `${host}/updateBalance`,
	contactdashboard: `${host}/contactdashboard `,
	journey_report: `${host}/journey_report`,
	journey_dashboard_report: `${host}/journey_dashboard_report`,
	custom_emailsenders: `${host}/custom_emailsenders`,
	domain_emailsenders: `${host}/domain_emailsenders`,
	selectedjourneyemails: `${host}/selectedjourneyemails`,
	all_contacts: `${host}/all_contacts`,
	getAllEmailDomain: `${host}/enterprises/get_all_email_domain`,
	getAudienceOptions: `${host}/audience/search_suggestions`,
	getAllProducts: `${host}/enterprises/all/products`,
	insta_data: `${host}/instagram`,
	export_contacts: `${host}/export_contacts`,
	cancelSubscription: `${host}/cancelSubscription`,
	transactionHistory: `${host}/transactionHistory`,
	contactFileHistory: `${host}/datasource_history`,
	listAllInvoice: `${host}/listAllInvoice`,
	allcustomers: `${host}/allcustomers`,
	allOrders: `${host}/enterprises/all/orderId`,
	notifications: `${host}/notifications`,
	notificationDetails: `${host}/notifications/details`,
	update_ads: `${audienceHost}/update_ads`,
	individual_campaign_search: `${audienceHost}/individual_campaign_search`,
	individual_campaign_search_contact_activity: `${audienceHost}/individual_campaign_search/contact_activity`,
	individual_journey_search: `${audienceHost}/individual_journey_search`,
	fbadsaudiences: `${host}/fbadsaudiences`,
	accountCapabilities: `${host}/accountCapabilities`,
	getcontactdatabydate: `${host}/get_contact_data_by_date`,
	delete_ads: `${audienceHost}/delete`,
	abort_ads: `${audienceHost}/abort_ads`,
	pause_ads: `${audienceHost}/pause_ads`,
	active_ads: `${audienceHost}/active_ads`,
	get_source: `${host}/getSourceData`,
	contactCount: `${host}/getTotalcontactsByenterprise`,
	countProratedValue: `${host}/countProratedValue`,
	emailtemplate: `${host}/emailtemplates/email`,
	inactiveInfoUpdate: `${host}/enterprises/updateInactiveinfo`,
	journey_recepient_activity: `${host}/journey_report/recipient`,
	journey_email_report_dashboard: `${audienceHost}/campaign/journey/dashboard`,
	individual_campaign_journey_report: `${audienceHost}/individual_campaign_journey`,
	conversion: `${host}/conversion`,
	journey_report_dash: `${host}/journey_report_dash`,
	journey_report_dash_new: `${host}/journey_report_dash_new`,
	journey_engagement: `${host}/journey_engagement`,
	removeuser: `${host}/users-permissions/removeuser`,
	monthly_notifications: `${host}/monthly_notifications`,
	customobjects: `${host}/customobjects`,
	customcolumns: `${host}/customcolumns`,
	getAudienceCustomObjects: `${host}/customobjects/getAudienceCustomObjects`,
	getAudienceCustomColumns: `${host}/customobjects/getAudienceCustomColumns`,
	smssender: `${host}/smssenders`,
	smstemplates: `${host}/smstemplates`,
	getMetadataDetails: `${host}/metadatadetails?type=:source`,
	saveMetadata: `${host}/factorealcampaigns/metadata/:id`,
	saveSMSMetadata: `${host}/smscampaign/metadata/:id`,
	downloadFailedContacts: `${host}/contacts/upload/report/:id`,
	journey_overview: `${host}/journey_overview`,
	sms_report: `${host}/sms-reports`,
	contactSampleFileUrl:
		"https://storage.googleapis.com/factoreal-global/static-assets/sample.csv",
	landingPageValidationKeys: {
		text: [
			"text",
			"textarea",
			"dropdown",
			"checkbox",
			"number",
			"date",
			"tel",
			"url",
			"email",
		],
		text_array: ["text", "textarea"],
		number: ["text", "number"],
		phone: ["text", "tel"],
		email: ["email"],
		date: ["date"],
		boolean: ["dropdown"],
		tel: ["tel", "text"],
		checkbox: ["text", "dropdown"],
		password: ["password"],
		url: ["url", "text"],
	},
	datasourceuploads_custom_confirmation: `${host}/datasourceuploads/custom_confirmation`,
	add_manually: `${host}/customobjects/single_create`,
	update_add_manually: `${host}/customobjects/updatesinglecreate`,
	delete_custom_record: `${host}/customobjects/deleterow`,
	custom_report: `${host}/customobjects/customReport`,
	createcolumns: `${host}/customcolumns/createcolumns`,
	validateBooleanValues: ["Yes\nNo"],
	customFileHistory: `${host}/custom_history`,
	getLandingPageScript: `${host}/fetchlandingpagescript`,
	alertDuration: 5000,
	fb_audience_count: `${audienceHost}/fbFilters`,
	get_enterprise_by_id: `${host}/enterprises/`,
	// userTimeout is in minutes
	userTimeout: 60,
	twitterdata: `${host}/twitteraccounts/saveAccount`, //twitter
	twitteraccounts: `${host}/twitteraccounts`,
	twitterAuth: `${host}/twitteraccounts/auth`,
	fetchCatalogData: `${host}/fbcatalogaccounts/fetchCatalog`,
	saveCatalogData: `${host}/fbcatalogaccounts`,
	getCatalogStatus: `${host}/fbcatalogaccounts`,
	removeCatalog: `${host}/fbcatalogaccounts`,
	getsmsettings: `${host}/getsmssettings`,
	smsdefaultsettings: `${host}/smsdefaultsettings`,
	smssettings: `${host}/smssettings`,
	domainsettings: `${host}/domainsettings`,
	getdomainsettings: `${host}/getdomainsettings`,
	smscampaigns: `${host}/smscampaigns`,
	smsIndividualContacts: `${host}/sms-individual-contacts`,
	smsIndividualRecipients: `${host}/smscampaign/individual-recipients-list`,
	smsIndividualRecipientSelected: `${host}/smscampaign/individual-recipients-selected/:id`,
	smsVendors: `${host}/sms-vendors`,
	deleteVendors: `${host}/deletecampaignvendors/:id`,
	smsCampaignSummary: `${host}/smscampaigns/:id`,
	smsCampaignDetails: `${host}/smscampaigns/campaign-details/:id`,
	smsSendNow: `${host}/smscampaign/:id/save`,
	smsUrlShortening: `${host}/globalconfigs`,
	estimateFactcoins: `${host}/estimate-factcoins/:id`,
	downloadOfflineReport: `${host}/offlinereports/create`,
	getOfflineReportStatus: `${host}/offlinereports/:id`,
	enterpriseSmsTemplates: `${host}/enterprisesmstemplates`,
	factorealsmstemplates: `${host}/factorealsmstemplates`,

	getemailtypes: `${host}/customobjects/getemailtype`,
	getCustomObjectsEmail: `${host}/customobjects/getCustomObjectsEmail`,
	getphonetypes: `${host}/customobjects/getphonetype`,
	getcolumntags: `${host}/customobjects/getcolumntags`,
	delete_single_record: `${host}/customobjects/deletemultiplerow`,
	mergetagcolumns: `${host}/customcolumns/mergetagcolumns`,
	getcustomtags: `${host}/customobjects/getcustomtags`,
	download_audience_contacts: `${host}/audience/download_contacts`,
	deleteListContacts: `${host}/delete_list_contacts`,
	// Linkedin API
	linkedinAccessToken: `${host}/linkedinaccounts/access_token`,
	linkedinConfig: `${host}/linkedinaccounts/create`,
	linkedinAccounts: `${host}/linkedinaccounts`,
	linkedinUserInfo: `${host}/linkedinaccounts/config_user_info`,
	linkedinPages: `${host}/linkedinaccounts/linkedin_pages`,
	domainVerificationBtnStatus: `${host}/domain/verify-status`,
	mediaFormats: /(\.jpg|\.jpeg|\.png|\.mp4)$/i,
	mediaFormatsWhatsapp: /(\.jpg|\.jpeg|\.png|\.mp4|\.3gpp|\.pdf)$/i,
	imageFormatsWhatsapp: /(\.jpg|\.jpeg|\.png)$/i,
	videoFormatsWhatsapp: /(\.mp4|\.3gpp)$/i,
	audioFormatsWhatsapp: /(\.mp3|\.aac|\.amr)$/i,
	docFormatsWhatsapp: /(.pdf)$/i,
	mediaFormatAlert: "jpg, jpeg, png and mp4",
	mediaFormatAlertForWhatsapp: "mp4, 3gpp, jpeg, png and pdf",
	imageFormatAlertForWhatsapp: "jpg, jpeg and png",
	videoFormatAlertForWhatsapp: "mp4 and 3gpp",
	docFormatAlertForWhatsapp: "pdf",
	maxTwitterVideoSize: 15728640,
	maxVideoSize: 104857600, //100MB in bytes. (15MB=15728640)
	maxImageSize: 5242880, //5MB in bytes
	instagramMaxImageSize: 3145728, // *MB in bytes
	maxVideoSizeAlert: "100MB",
	maxTwitterVideoAlert: "15MB",
	maxImageSizeAlert: "5MB",
	instagramMaxImageSizeAlert: "3MB",
	maxTwitterImageCount: 4,
	maxInstagramImageCount: 10,
	maxImageCount: 9,
	notification_mediaFormat: /(\.jpg|\.jpeg|\.png|)$/i,
	notification_mediaFormatAlert: "jpg, jpeg, png",
	getSubscribers: `${host}/subscribers`,
	web_push_journey: `${host}/webpush/journey-list`,
	mobile_push_journey: `${host}/mobilepush/journey-list`,
	appAttributes: `${host}/appattributes`,
	FreeformDocFormatsWhatsapp:
		/(\.pdf|\.docx|\.ppt|\.pptx|\.xls.|\.xlsx|\.csv|\.txt)$/i,
	FreeformDocFormatAlertForWhatsapp:
		"pdf, docx, ppt/pptx, xls/xlsx, csv and txt",

	formValidationNames: {
		text: "Text",
		text_array: "Text Area",
		textarea: "Text Area",
		number: "Number",
		phone: "Phone",
		email: "Email",
		date: "Date",
		boolean: "Boolean",
		tel: "Phone Number",
		password: "Password",
		url: "Website",
		checkbox: "Checkbox",
		dropdown: "Dropdown",
	},
	allmergetags: `${host}/customobjects/allmergetags`,
	showFactcubeKPI: false,
	createBqEnterprise: `${host}/createBqEnterprise`,
	updateContactTags: `${host}/enterprises/updateContactTags`,
	defaultSMSVendors: `${host}/smsdefaultvendors`,
	searchSenders: `${host}/searchSenders`,
	getSMSCampList: `${host}/smscampaign-list`,
	getSMSJourList: `${host}/sms/journey-list`,
	getSmsByJId: `${host}/journey_sms_blocks/`,
	getWhatsappByJId: `${host}/journey_whatsapp_blocks/`,
	getUrlBySmsId: `${host}/smscampaign-urls/`,
	getUrlsByJourneySmsId: `${host}/smsjourneyurls/`,
	journeyEmailUrls: `${host}/journeys/urls`,
	journeyByName: `${host}/journeys`,
	emailCampaignByName: `${host}/emailcampaigns`,
	selectedjourneysms: `${host}/selectedjourneysms`,
	sms_test_numbers: `${host}/sms-test-numbers`,
	sms_test_campaign: `${host}/test-campaign`,
	createSMStemplate: `${host}/smstemplates`,
	updateTemplateName: `${host}/smstemplates/updateName`,
	checkSMStemplateName: `${host}/smstemplates/checkUnique/`,
	cloneSMStemplate: `${host}/smstemplates/createClone/`,
	webpushtemplates: `${host}/webpushtemplates`,
	createWebpushtemplate: `${host}/webpushtemplates`,
	updateWebpushTemplateName: `${host}/webpushtemplates/updateName`,
	checkWebpushtemplateName: `${host}/webpushtemplates/checkUnique/`,
	cloneWebpushtemplate: `${host}/webpushtemplates/createClone/`,
	webpush_template_search: `${host}/webpush_template_search`,
	approveTemplate: `${host}/enterprisetemplates/approval`,
	rejectTemplate: `${host}/enterprisetemplates/reject`,
	submitForApproveTemplate: `${host}/enterprisetemplates/submit_for_approval`,
	mobilepushtemplates: `${host}/mobilepushtemplates`,
	createMobilepushtemplate: `${host}/mobilepushtemplates`,
	updateMobilepushTemplateName: `${host}/mobilepushtemplates/updateName`,
	checkMobilepushtemplateName: `${host}/mobilepushtemplates/checkUnique/`,
	cloneMobilebpushtemplate: `${host}/mobilepushtemplates/createClone/`,
	mobilepush_template_search: `${host}/mobilepush_template_search`,
	getWebpushTemplateBasedOnStatus: `${host}/webpushtemplate_status_filter`,
	getMobilepushTemplateBasedOnStatus: `${host}/mobilepushtemplate_status_filter`,
	getConversationAddonStatus: `${host}/addon-available/`,
	getAgentRoutingRules: `${host}/agentroutingcriterias`,
	getConversationBotDetails: `${host}/instabot/conversations_bots`,
	deleteAgentRoutingRules: `${host}/agentroutingcriterias/`,
	updateAgentRoutingRules: `${host}/agentroutingcriterias/`,
	getAgentDetails: `${host}/botusers/fetch-agent`,
	getEditRules: `${host}/agent-routing-rules/:id`,
	getAllbotDetails: `${host}/botmappings/fetch-bots`,
	assignBotChannel: `${host}/botmappings`,
	createAgent: `${host}/botusers/create-agent`,
	instabotLoginUrl: `${host}/botusers/login-url`,
	botMappingAvailability: `${host}/botmappings/is-available/`,
	getBotActiveCount: `${host}/botmappings/live-sessions`,
	getDataonSelectedDate: `${host}/botmappings/bot-reports`,
	channelOptions: `${host}/botmappings/bot-channel-options`,

	getsubjectlines: `${host}/generate-subject-lines`,
	getHtmlMetadata: `${host}/process-image`,

	release_sender: `${host}/releaseSender`,
	smsnumbercosts: `${host}/smsnumbercosts`,
	omittedList: [
		"SMS Consent",
		"WhatsApp Consent",
		"Email DND List",
		"SMS DND List",
		"Webpush DND List",
		"Mobilepush DND List",
	],
	webSubscribers: `${host}/websubscribers`,
	approval_summary: `${host}/approval_summary`,
	transaction_push: "https://0997913e00b5.ngrok.io/transactional_push",
	smssettingsbycountries: `${host}/smssettingsbycountries`,
	updatesmssettingsbycountry: `${host}/updatesmssettingsbycountry`,
	visitorscountry: "https://extreme-ip-lookup.com/json/",
	webPushStaticEvents: `${host}/webpushstaticevents`,
	mobilePushStaticEvents: `${host}/mobilepushstaticevents`,
	getsmssettingsbycountry: `${host}/getsmssettingsbycountry`,
	sms_india_delimiter_start_char: "{#",
	sms_india_delimiter_end_char: "#}",
	webpush_overview_journey_report: `${audienceHost}/journey/overview/webpush/report`,
	webpush_journey_report: `${audienceHost}/journey/webpush/report`,
	webpush_journey_report_data: `${audienceHost}/journey/webpush/report-data`,
	mobilepush_overview_journey_report: `${audienceHost}/journey/overview/mobilepush/report`,
	mobilepush_journey_report: `${audienceHost}/journey/mobilepush/report`,
	external_push_overview_journey_report: `${audienceHost}/journey/overview/externalpush/report`,
	external_push_journey_report: `${audienceHost}/journey/externalpush/report`,
	social_post_overview_journey_report: `${audienceHost}/journey/overview/socialpost/report`,
	social_ad_overview_journey_report: `${audienceHost}/journey/overview/socialad/report`,
	webpushMaxBodyLength: import.meta.env.WEBPUSH_MAX_BODY_LENGTH || 96,
	webpushMaxTitleLength: import.meta.env.WEBPUSH_MAX_TITLE_LENGTH || 30,
	webpushMaxCTALength: import.meta.env.WEBPUSH_MAX_CTA_LENGTH || 14,
	submitforapproval: `${host}/submitforapproval`,
	approvejourney: `${host}/approvejourney`,
	rejectjourney: `${host}/rejectjourney`,
	campaign_summary_absolute_url: `${host}/campaign/:id/campaign-summary/:data_id`,
	instagram_config: `${host}/instagramaccounts`,
	igTemplates: `${host}/instagramtemplates`,
	instagram_menu: `${host}/instagramaccounts-menu`,
	messenger_menu: `${host}/messengeraccounts-menu`,
	instagram_restriction: `${host}/instagramaccounts/checkPublishingQuota`,
	defaultEmailDomain: "fctly.de",
	update_image_folder: `${host}/update_image_folder`,
	fetch_all_templates: `${host}/fetch_all_templates`,
	landing_page_url: `${host}/save_landingpage_to_s3`,
	updateCartAbandon: `${host}/enterprises/updateCartAbandon`,
	logout: `${host}/user/logout`,
	dnd_settings: `${host}/dndsettings`,
	whatsappaccounts: `${host}/whatsappaccounts`,
	acessible_list_whatsapp: `${host}/whatsappjournies/journey-list`,
	selectedjourneywhatsapp: `${host}/journey_whatsapp_blocks`,
	whatsapptemplates: `${host}/whatsapptemplates`,
	check_unique_templates: `${host}/whatsapptemplates/checkUnique`,
	clone_whatsapp_template: `${host}/whatsapptemplates/createClone`,
	clone_landing_page: `${host}/clone_landing_page`,
	whatsapp_template_search: `${host}/whatsapptemplates/whatsapp_template_search`,
	landing_page_search: `${host}/landing_page_search`,
	is_trail_plan: `${host}/is_trail_plan`,
	tfa_update: `${host}/tfa_update`,
	sms_template_search: `${host}/sms_template_search`,
	template_search: `${host}/template_search`,
	sender_number_search: `${host}/whatsapptemplates/sender_number_search`,
	category_search: `${host}/whatsapptemplates/category_search`,
	language_search: `${host}/whatsapptemplates/language_search`,
	whatsappJourneyDashboard: `${audienceHost}/journey/overview/whatsapp/report`,
	whatsappIndividualCampaign: `${audienceHost}/journey/whatsapp/report`,
	whatsapp_doc_size: 100000000,
	whatsapp_image_size: 5000000,
	whatsapp_video_size: 16000000,
	conversational_bot_api: "https://bot.me.satis.fi/account/loginByJwt",
	get_user_details: `${host}/get_user_details`,
	bot_url: "http://bot.me.satis.fi",
	moderationdetails: `${host}/moderationdetails`,
	whatfix_url: [
		"https://whatfix.com/825f85f0-64e8-11ea-81e9-bacbbe07b880/embed/embed.nocache.js",
		"https://cdn.whatfix.com/prod/825f85f0-64e8-11ea-81e9-bacbbe07b880/embed/embed.nocache.js",
	],
	whatsapp_commerce_products: `${host}/fbcatalogaccounts/fetchProducts/`,
	getMobilePushIdType: `${host}/mobilepush_idtype`,
	mobilepush_image_size: 5242880,
	journey_wizard_goal_timeout: 3000,
	audienceEvents: `${host}/audience/events`,
	markettingCalendar: {
		read: `${host}/factorealnotes/get-campaign-journey`,
		delete: `${host}/factorealnotes/delete-campaign-journey/`,
		reschedule: `${host}/factorealnotes/reschedule-campaign-journey/`,
		readNote: `${host}/factorealnotes/get-all-factoreal-notes`,
		createNote: `${host}/factorealnotes/create-factoreal-notes`,
		updateNote: `${host}/factorealnotes/edit-factoreal-notes`,
		deleteNote: `${host}/factorealnotes/delete-factoreal-notes`,
	},
	autosegment: {
		read: `${host}/autosegmentconfigs/get-autosegments`,
		update: `${host}/autosegmentconfigs/configure-autosegments/`,
	},
	audianceAutoSegment: {
		read: `${host}/autosegmentconfigs/get-autosegments-list`,
	},
	plans_limit_validation: `${host}/plans_limit_validation/:id`,
	signupUrl: `${host}/portalSignUp`,
	emailValidator: `${host}/email-validate?email=:email`,
	location_list: `${host}/fbla/getLocations`,
	pages_list: `${host}/fbla/getPageList`,
	product_catalogue: `${host}/fbla/getCatalogueList`,
	product_set: `${host}/fbla/getProductSetList`,
	create_lookalike: `${host}/fbla/createLookalikeAudience`,
	reach_estimate: `${host}/fbla/getReachEstimate/`,
	get_audience: `${host}/fbla/getAudience`,
	delete_lookalike: `${host}/fbla/deleteAudience/`,
	fb_customer_count: `${host}/fbla/getCustomerCount`,
	FMMConfiguration: `${host}/feature/FMM`,
	fetchFactcubesDashboard: `${host}/fetchFactcubesDashboard`,
	updateFactcubesDashboardList: `${host}/updateFactcubesDashboardList`,
	factcubesCreateUser: `${host}/factcubesCreateUser`,
	factcubesDeleteUser: `${host}/factcubesDeleteUser`,
	currency_list: `${host}/matomoconfigs/fetch-currency-list`,
	timezones: `${host}/matomoconfigs/fetch-timezones`,
	tracking_script: `${host}/matomoconfigs/fetch-tracking-script`,
	matomoconfig: `${host}/matomoconfigs`,
	tooltip: {
		send_time_recommendation:
			"Send time optimization enables the platform to determine the best time to send the message for maximum conversion. This can be enabled either at enterprise level (optimized uniformly across all contacts), or at individual level (optimized for each individual contact). A contact will not have any individual level optimization till we have enough data points to make optimization valuable. If platform cannot determine optimized send time, then the message will be sent immediately.",
	},
	contactAttributes: `${apiHost}/contact-management/contact-attribute`,
	apiRequestReport: `${apiHost}/contact-management/report`,
	gd_home_dashboard: `${host}/gd-dashboards?type=home_dashboard`,
	aiAgentDetails: `${host}/ai-agent-bot-configs`,
	aiAgentBots: `${host}/ai-agent-bots`,
	aiDefaultBotConfigs: `${host}/ai-default-bot-configs`,
	whatsapp_templates_intimation_settings: `${host}/whatsapp-template-intimation-configs`,
	whatsapp_template_events: `${host}/whatsapp-template-events`,
	get_feature_flags: `${host}/feature-flags`,
	hide_announcement: `${host}/users-permissions/hide-announcement`,
	flowType: {
		SMS_CAMPAIGN: "SMS Campaign",
		JOURNEY_LIST: "Journey List",
	},
	campaigns: `${audienceHost}/genericData/factorialcampaigns`,
	smsCampaigns: `${audienceHost}/genericData/smscampaigns`,
	journeys: `${audienceHost}/genericData/journeybuilders`,
	socialCampaigns: `${host}/factorealcampaigns/campaigns`,
	productsList: `${audienceHost}/enterpriseData/products`,
	gdFactcubes: `${host}/gd-factcubes`,
	TOKEN_KEY: "user_token",
	journeybuilderslist: `${host}/journeybuilderslist`,
	updateDoubleOptinFlag: `${host}/enterprises/updateDoubleOptinFlag`,
	landingPagesList: `${host}/landingpages?field=name,id`,
};

if (constants.captcha_whitelist.includes(hostname)) {
	// all the production values are reassigned here
	constants.facebook_app_id = "515199124391282";
}

let url = "";
let token = "";
let defaultFactcubeWorkspace = "";

if (constants.all_env_hostnames.PROD.includes(hostname)) {
	url = "https://analytics.factoreal.com";
	token =
		"dGVzdHVzZXI6YXBpLXVzZXI6Zk5zZnN4aEdBdDRROVZDUTFpL3hLaGNGL3ZQVWJqMHE=";
	defaultFactcubeWorkspace = "f650622a5c4d4b1d956af010e4ffed3b";
} else {
	url = "https://analytics-me.satisfi4.com";
	token =
		"cmlzaGF2LmJhc3UuMjU4NTQxNWEtODk4ZC00ZDhmLTkyYzItMmZjMjQ3ZGY3ZGM1OkFQSV9UT0tFTjpBTStVUDdrQmdQQy96Z2pBd1pQUEowUVZuSWsrNzdzSw==";
	defaultFactcubeWorkspace = "enterprise_8";
}

export const backend = url;
export const tiger_token = token;
export const gdcn_workspace = defaultFactcubeWorkspace;

if (hostname.includes("comviva")) {
	constants.headerTitle = "Mobilytix";
} else if (hostname.includes("optimus")) {
	constants.headerTitle = "Optimus";
} else if (hostname.includes("localhost")) {
	constants.headerTitle = "localhost";
}

export const fb_mapping = {
	1: "An unknown error occurred, please retry after some time",
	4: "Application request limit reached",
	10: "Application does not have permission for this action",
	17: "User request limit reached",
	100: "Invalid parameter",
	102: "Your Facebook authentication key has expired, please authorize Marketing Engine again [URL]",
	104: "Incorrect signature",
	190: "Invalid OAuth 2.0 Access Token",
	200: "Your Facebook authentication key has expired, please authorize Marketing Engine again [URL]",
	294: "Managing advertisements requires the extended permission ads_management and an application that is whitelisted to access the Marketing API",
	368: "Your message couldn't be sent because it includes content that other people on Facebook have reported as abusive",
	2606: "Unable to display a preview of this ad, please re-upload the media.",
	2607: "The given currency is invalid for usage with ads.",
	2615: "Invalid call to update this adaccount",
	2654: "Failed to create custom audience.",
	5000: "An unknown error occurred, please retry after some time.",
	// "1349118": "",
	1359101: "Please add a valid payment method to your ad account.",
	1359036:
		"You've reached the ads limit, 1000 supported for your Facebook account.",
	1443017:
		"This ad cannot be delivered because the Page it targets has not been published",
	1487002: "Ad parameter has invalid value or missing required parameter",
	1359106:
		"Invalid Campaign ID: You must specify a campaign, and the campaign specified must belong to the account specified and must not be deleted.",
	1487007:
		"Campaign Ended: You can't edit ads in a campaign that has ended. Please create a new ad within this campaign, update the campaign end time, pick another campaign, or create a new campaign.",
	1487010:
		"Ad Bid Too High: Your bid is above the maximum for its type and placement. Please try again with a value below the maximum if you would like to raise your bid.",
	1487013:
		"Bid Too Low: Your bid is below the minimum for its placement and type. If you don't want your ad to run at the minimum bid rate, please pause it. Otherwise, please increase the bid to be within the suggested range.",
	1487014:
		"Campaign budget was too low. Please increase the daily budget to at least $2.",
	1487015: "The ad creative is invalid",
	1487065:
		"Ad Missing Targeting Spec: Ad spec needs a targeting spec. Please use targeting field to specify what audience the ad should be shown to. Field 'countries' is required; all others are optional.",
	1487087: "Ad Create Failed",
	1487089: "Target Spec Invalid",
	1487090: "Ad Edit Failed",
	1487108:
		"Invalid Cities: Please check that the format in which you are specify the cities is correct, and if you specify IDs, that they are of the correct type. This can not be the the ID of the page for the city; city ids are returned by, `/search?type=adcity`.",
	1487124:
		"Invalid Connection: You can only specify connections to objects you are an administrator or developer of.",
	1487133:
		"Invalid Negative Connections: If you specify negative targeting, you must be the administrator or developer of the objects whose fans you want to specify to exclude.",
	1487172: "Could not save creative",
	1487174: "Invalid Image Hash",
	1487194:
		"Permission Error: Either the object you are trying to access is not visible to you or the action you are trying to take is restricted to certain account types.",
	1487199:
		"Ad targeting does not match targeting of the story: The targeting specified for this ad is not compatible with the story being boosted. Check the privacy and language/country targeting of the story you are trying to sponsor.",
	1487202:
		"Invalid object - not admin or object not public: The user is not an admin of the object or the object is not publicly accessible.",
	1487211:
		"Invalid URL For Creative Destination: Creative must have a valid destination URL, and if attached object is page, destination must match page.",
	1487225:
		"You've reached the daily ads limit 1000 supported for your Facebook account. Please try again tomorrow.",
	1487244: "Campaign Update Failed",
	1487246: "Campaign Creation Failed",
	1487256:
		"Targeting declined due to policy: Invalid ads targeting. The targeting spec was declined due to policy restrictions.",
	1487283:
		"Not Allowed To Use View Tags: Only some partners are allowed to use view tags. Please verify that you are using an approved account.",
	1487301:
		"Custom Audience Unavailable: The custom audience you're trying to use hasn't been shared with your ad account. Please create or choose a different custom audience, or ask the owner of the custom audience to let you use it.",
	1487346:
		"The post does not belong to the specified Page: Post to be promoted does not belong to the Page specified.",
	1487366:
		"Custom Audience Has Been Deleted: Cannot use deleted custom audience. Please choose another audience.",
	1487376:
		"Conversion Spec Needed: For ads pointing to an offsite location with a non-zero bid on actions, you must specify the conversion spec.",
	1487380:
		"Invalid aggregation day for conversion data. The aggregation day must be larger than or equal to 1.",
	1487390: "Adcreative Create Failed",
	1487391:
		"Cannot Use Syndicated Audiences From Multiple Partners: When specifying partner-created custom audiences for an ad, all audiences must be from the same provider.",
	1487396: "Failed to update the creative",
	1487424:
		"Ad Needs Exclusion Targeting: This ad cannot be created with the targeting spec you selected. Your ad has a conversion objective that users can only do once, so you must target the ad at those users who have not already converted.",
	1487465: "Invalid CPA Bid",
	1487472: "This type of page post is not eligible to be promoted.",
	1487477:
		"Conversion Tracking Pixel Permission Error: The conversion tracking pixel you're trying to use is owned by another user and hasn't been shared with you. Please use a tracking pixel that's been shared with you or create a new one.",
	1487485: "Too many async requests",
	1487506:
		"Campaign budget is too low. Please increase the daily budget to at least $2.",
	1487557: "No supported fields were provided for updating the campaign",
	1487558: "No supported fields were provided for updating the ad",
	1487559: "Ad Update Failed",
	1487573: "You must specify an object_id for this adcreative type",
	1487742:
		"There have been too many calls from this ad-account. Wait a bit and try again.",
	1487756:
		"You have overlapping locations specified in the geo_locations field. Your broader option will override the narrower option, please remove one to proceed.",
	1487790:
		"The promoted object is invalid: it could have been deleted or never existed.",
	1487881:
		"The given prediction id in a reach and frequency campaign is not reserved.",
	1487882:
		"The given reservation in a reach and frequency campaign is not finalized yet.",
	1487884:
		"The given reservation in a reach and frequency campaign is already finalized",
	1487885:
		"The prediction in a reach and frequency campaign is already reserved.",
	1487886: "This indicates the operation fails for an unknown reason.",
	1487887: "The given page types are not supported by the inventory manager.",
	1487915:
		"A finalized prediction order can not be cancelled. You can create a new prediction or delete the campaign.",
	1634013:
		"Conversion Spec Targets Invalid ID: You are targeting an ID in your conversion spec without admin permissions on that object.",
	1667002:
		"This Promotion Can't Be Edited: This can't be edited because you promoted it from your Page. Find the post on your Page to pause, delete, or update budget for this promotion.",
	1815826:
		"Your bid strategy is invalid. Current available bid strategies are LOWEST_COST_WITHOUT_CAP, LOWEST_COST_WITH_BID_CAP, and TARGET_COST. Please choose a valid bid strategy to suit your business goals. Effective as of 3.0.",
	1815829:
		"You are trying to set a bid strategy on an ad set in an ad campaign with campaign budget optimization enabled. Setting bid strategy on such an ad set is not allowed. Either remove bid strategy on your ad set or disable campaign budget optimization on your campaign. Effective as of 3.0.",
	1815830:
		"You are trying to set a bid strategy on an ad set in an ad campaign that does not use Auction buying type. Setting bid strategy on such an ad set is not allowed. Effective as of 3.0.",
	1815857:
		"Bid amount required: you must provide a bid cap or target cost in bid_amount field. For LOWEST_COST_WITH_BID_CAP you must provide bid_amount field to set a bid cap. For TARGET_COST, you must provide bid_amount field to set an average target cost goal. Effective as of 3.0.",
	1815858:
		"You can't set a bid cap on ad sets with LOWEST_COST_WITHOUT_CAP bid strategy. Please either remove bid_amount or change to use LOWEST_COST_WITH_BID_CAP with bid_amount. Effective as of 3.0.",
	1815067:
		"Optimization Goal Isn't Available: You can't use the selected optimization goal for your campaign objective. Please select a different goal and edit your campaign.",
	1798130:
		"We disallow creation of empty product sets for Dynamic Ads. Please add products to your catalog and create a set that contains at least one product.",
	2310025:
		"Unable to Create Campaign Using This Ad Account. To create Collaborative Ads campaigns, Brand Advertisers must use a separate ad account for each merchant they partner with. Make sure you use a separate ad account associated with the merchant who owns this catalog segment. Under limited availability.",
	2310039:
		"Unable to Create Campaign Using This Catalog Segment. You cannot use this ad account to run ads for this catalog segment. The business created this catalog segment for a Brand Advertiser to use in Collaborative Ads. Choose a different ad account, or use this ad account to run campaigns using a product catalog instead. Under limited availability.",
};

export default constants;

export { audienceHost, host };

export const newUIConstants = {
	contactsData: `${host}/account/billing/contactsData`,
	billingSetup: `${host}/account/billing/billingSetup`,
	phoneNumbers: `${host}/smssendernumbers/fetchsmsnumbers`,
	reviewProductPricing: `${host}/getProductsPrice`,
	addNumber: `${host}/asksupporttobuynumber`,
	payNow: `${host}/puchaseplan`,
	userPlan: `${host}/purchasedplans`,
	calendlyLink: "https://calendly.com/onboarding-96/",
};
